import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DateTimeRange from "../../../components/common/DateTimeRange";
import { url } from "../../../Constant";
import axios from "axios";
import Select from "react-select";
import $ from "jquery";
import { toast } from "react-toastify";
import { useAuth } from "../../../Context/AuthProvider";
import moment from "moment";
import { checkIndividualPermission } from "../../../Utils/PermissionFunctions";

const NewCallConferencing = () => {
  const { auth } = useAuth();

  const [lastId, setLastId] = useState("");
  const [numbersOptions, setNumbersOptions] = useState([]);
  const [selectedNumber, setSelectedNumber] = useState([]);
  const [errorEnable, setErrorEnable] = useState(false);
  const [loader, setLoader] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [submittedData, setSubmittedData] = useState({
    subject: "",
    rnbcs: "1",
    nor: "1",
    vpbx_id: auth.vpbx_id,
  });
  const getLastIdCall = () => {
    let api = "";
    if (auth.role === "2") {
      api = "lastId-Call";
    } else {
      api = "user-lastId-Call";
    }

    axios
      .post(
        url + api,
        {},
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )

      .then(function (response) {
        if (response.data.code === 200) {
          setLastId(response.data.data.confno);
        }
      });
  };
  const getNumbers = () => {
    let api = "";
    if (auth.role === "2") {
      api = "create-call-conference";
    } else {
      api = "user-create-call-conference";
    }

    axios
      .post(
        url + api,
        { vpbx_id: auth.vpbx_id },
        {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      )

      .then(function (response) {
        if (response.data.code === 200) {
          let optionsForMultiSelect = [];
          response.data.data.map((val) => {
            optionsForMultiSelect.push({
              value: val.name,
              label: val.name,
            });
          });
          setNumbersOptions(optionsForMultiSelect);
        }
      });
  };
  useEffect(() => {
    if (
      auth.role === "1" ||
      (auth.role === "3" &&
        !checkIndividualPermission("conferencing", "read_and_write"))
    ) {
      window.location.href = "/";
    }
    getLastIdCall();
    getNumbers();
  }, []);
  const handleSelect = (e) => {
    let array = Array.isArray(e) ? e.map((x) => x.value) : [];
    setSelectedNumber(array);
  };
  const createNewConferencing = () => {
    setErrorEnable(true);
    setLoader(true);
    var sms_checkbox =
      $("#sms_checkbox").is(":checked") === true ? "yes" : "no";
    var email_checkbox =
      $("#email_checkbox").is(":checked") === true ? "yes" : "no";
    var voice_call = $("#voice_call").is(":checked") === true ? "yes" : "no";
    let data = {
      confno: lastId,
      members: selectedNumber,
      subject: submittedData.subject,
      sms: sms_checkbox,
      email: email_checkbox,
      voicecall: voice_call,
      rnbcs: submittedData.rnbcs,
      nor: submittedData.nor,
      boltondate:
        moment(startDate).format("YYYY-MM-DD") +
        " - " +
        moment(endDate).format("YYYY-MM-DD"),
      vpbx_id: submittedData.vpbx_id,
    };

    if (
      submittedData.subject !== "" &&
      // submittedData.rnbcs !== "" &&
      // submittedData.nor !== "" &&
      selectedNumber.length !== 0 &&
      startDate !== "" &&
      endDate !== ""
    ) {
      let api = "";
      if (auth.role === "2") {
        api = "store-call-conference";
      } else {
        api = "user-store-call-conference";
      }

      axios
        .post(url + api, data, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
        .then(
          (response) => {
            if (response.status === 200) {
              if (response.data.message === "Data added") {
                setLoader(false);
                toast.success("Call Conferencing Added Successfully", {
                  position: toast.POSITION.TOP_RIGHT,
                  autoClose: 1500,
                });
                setTimeout(() => {
                  window.location.href = "/call-conferencing";
                }, 2000);
              }
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      setLoader(false);
    }
  };
  return (
    <div className="dashboardWrp">
      <div className="uk-container uk-container-small">
        <div className="dashboardTop">
          <div uk-grid="" className="uk-grid uk-grid-small">
            <div className="uk-width-2-3">
              <div className="dashboardIntro">
                <Link to="/call-conferencing">
                  <img src="./assets/images/zong/chevron--left.svg" uk-svg="" />
                  <span>Back to VPBX manager</span>
                </Link>
                <h3>Create Call Conferencing</h3>
                <p>
                  Please enter the details for the new call conferencing,
                  including the subject and duration period.
                </p>
              </div>
            </div>
            {/* <div className="uk-width-1-3">
              <div className="dashboardIntro uk-text-right">
                <button>EXPORT DATA</button>
              </div>
            </div> */}
          </div>

          <form action="javascript:void(0);">
            <div className="formCreateMain">
              <div className="uk-grid uk-grid-small">
                <div className="uk-width-1-1@m uk-margin-top">
                  <legend className="uk-legend">Add details</legend>
                </div>
                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Conference number</label>
                  <input
                    className="uk-input"
                    type="text"
                    aria-label="Input"
                    disabled
                    value={lastId}
                  />
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>Subject</label>
                  <input
                    className="uk-input"
                    type="text"
                    placeholder="Enter subject..."
                    aria-label="Input"
                    onChange={(e) => {
                      setSubmittedData({
                        ...submittedData,
                        subject: e.target.value,
                      });
                    }}
                  />
                  {errorEnable && submittedData.subject === "" && (
                    <div className="formErrors">subject is required</div>
                  )}
                </div>

                <div className="uk-width-1-2@m uk-margin">
                  <label>During period</label>
                  <DateTimeRange
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                  />
                  {errorEnable && startDate === "" && endDate === "" && (
                    <div className="formErrors">During period is required</div>
                  )}
                </div>

                <div className="uk-width-1-2@m uk-margin-top">
                  <label>To</label>
                  <Select
                    isMulti
                    name="agents"
                    options={numbersOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={(e) => handleSelect(e)}
                  />
                  {errorEnable && selectedNumber.length === 0 && (
                    <div className="formErrors">please select to numbers</div>
                  )}
                </div>

                <div className="uk-width-1-1@m uk-margin-top">
                  <div className="formActionBtn uk-text-right">
                    {/* <button className="whiteBtn">Cancel</button> */}
                    <button
                      className="pinkBtn"
                      onClick={() => createNewConferencing()}
                    >
                      {loader ? (
                        <div uk-spinner="" className="loader">
                          Adding
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewCallConferencing;
